class CardsProduct {
  constructor() {
    this.cards = [
      ...document.querySelectorAll(".collection-listing .product-block"),
      ...document.querySelectorAll(".product-card-updated"),
    ];

    this.addEventOption();
  }

  addEventOption() {
    this.cards.forEach((card) => {
      const inputs = card.querySelectorAll("input[type='radio']");
      const variantsTextJson = card.querySelector("[data-card-variants]");
      if(!variantsTextJson) return;
      const variantText = variantsTextJson.textContent;
      const variantJson = JSON.parse(variantText);

      if (!inputs) return;

      inputs.forEach((input) => {
        const currentVariant = variantJson.find(
          (variant) => variant.title == input.value
        );

        const { price } = currentVariant;

        input.addEventListener("click", (e) => {
          this.toggleOption({
            card,
            price,
          });
        });
      });
    });
  }

  toggleOption({ card, price }) {
    const priceSelector = card.querySelector(".product-block__price");
    priceSelector.innerHTML = `<span class="price">${this.formatMoney(
      price
    )}</span>`;
  }

  formatMoney(cents, currency = "USD") {
    const dollars = cents / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
    }).format(dollars);
  }
}

const initCardsProduct = () => {
  new CardsProduct();
};

export default initCardsProduct;
